(function () {
  'use strict';


  angular
    .module('rosterScoringReport')
    	.directive('focusOn',function($timeout) {
		return {
			restrict : 'A',
			link : function(vm,$element,$attr) {
				vm.$watch($attr.focusOn,function(_focusVal) {
					$timeout(function() {
						_focusVal ? $element[0].focus() : $element[0].blur();
					});
				});
			}
		}
	})
    .controller('RosterScoringReportCtrl', RosterScoringReportCtrl);

  function RosterScoringReportCtrl($sce,CommonMasterData,MessageService,CommonLogicService,AutoRosterScheduleService, AdminSnapService, PopupManager) {
    var vm = this;
    vm.ctrlName = 'rosterScoringReport';

    vm.model = {
            searchPanelToggle:true,
            searchCriteria:{
              cycle:null,
              crewType:null
            },
            masterList: {
              cycleList:[],
              snapshots:[],
              scorings : []
            },
            initialSearchDone:false,
            reportServerBaseUrl : null,
            reportDataUrl : ""
        };


    vm.clickOnSearch = function () {
        vm.model.searchPanelToggle = ! vm.model.searchPanelToggle;
        vm.model.initialSearchDone=false;
    };

    vm.submitSearch = function (params){
      searchScoringReportList(params)
    	//search(params);
    };

    function searchScoringReportList(searchParams){
      vm.model.searchPanelToggle = false;
      CommonMasterData.getScoringVersionByCycleIdAndCrewType(searchParams.cycle.cycleId,searchParams.crewType.crewTypeCode,
        function (snapshots) {
          vm.model.masterList.scorings = snapshots;
        },
        function (error) {
          MessageService.error(error);
        }
      );

    }


    vm.changeSearchField = function(searchParams, flag) {

      if(flag === 'cycle') {

        if (searchParams.cycle != null && !angular.isUndefined(searchParams.cycle.cycleId)) {

          CommonMasterData.getSnapShotsBYCycleId(searchParams.cycle.cycleId,
            function (snapshots) {
              vm.model.masterList.snapshots = snapshots;
            },
            function (error) {
              MessageService.error(error);
            }
          );

        }

      }
    };

    vm.clickOnRow = function (selectedRow, flag) {
      if (flag === 'restore') {
        restoreGridDuty(selectedRow);
      } else {
        //loadBirtReport(selectedRow);
        loadPopup(selectedRow);
      }
    };

    function restoreGridDuty(selectedRow) {
      var saveRosterRestoreReq = AdminSnapService.formatRestoreGridRequest(selectedRow);
      AdminSnapService.restoreGridDuty(saveRosterRestoreReq, function(response) {
          if (response.success) {
            MessageService.success('Roster restore from selected grid has started.');
          } else {
            MessageService.error(response.errors[0]);
          }
        }, function(error) {
          MessageService.error(error[0]);
        });
    }

    function loadBirtReport(selectedRow){
      var url = CommonLogicService.getReportUrl('roster_scoring_report.rptdesign',getSearchParamMap(selectedRow), 'Y', 'Y');
      vm.model.reportDataUrl = $sce.trustAsResourceUrl(url);
      window.open(url);
    }

    function loadPopup(selectedRow) {
      var details = selectedRow;
      PopupManager.openModal('SHOW_ROSTER_SCORING', details, function(){});
    }


    function getSearchParamMap(param) {
      var searchParamMap = {};
      searchParamMap["snapshotName"] = param.snapshotName;
      searchParamMap["scoreVersion"] = param.scoreName;
      searchParamMap["snapshotScoreId"] = param.snapshotScoreId;
      searchParamMap["score"] = param.score;
      searchParamMap["referrer"] = window.location.origin;

      return searchParamMap;
    }


    CommonMasterData.getReportServerBaseUrl(
	    	function (baseUrl) {
	            vm.model.reportServerBaseUrl = baseUrl;
	        },
	        function (error) {
	            MessageService.error(error);
	        }
	    );

    AutoRosterScheduleService.getRosterCycles(function (response) {
      vm.model.masterList.cycleList = response;
    },function (error) {});

    CommonMasterData.getCrewTypeList(function (crewTypeList) {
      vm.model.masterList.crewTypeList = crewTypeList;
    }, function () {
      console.log('Crew Type list retrieval error');
    });

  }


}());
